import i18n from 'modules/core/lib/i18n'

import { InsightTableType } from 'modules/finance/components/FinancialWorkspace/types/table'
import { useOnExport } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/exports/useExport'
import { resolveTitle } from 'modules/finance/components/FinancialWorkspacePayroll/components/Table/const'
import { usePayrollGroupData } from 'modules/finance/components/FinancialWorkspacePayroll/hooks/usePayrollGroupData'

import { GroupBySelector } from './GroupBy'

export const useTableProps = () => {
  return {
    useOnExport,
    titleResolver: resolveTitle,
    groupByComponent: GroupBySelector,
    useDataFetch: usePayrollGroupData,
    emptyStateProps: {
      title: i18n.t('finance.financial_workspace.breakdown_table.empty_state.payroll.title'),
      description: i18n.t(
        'finance.financial_workspace.breakdown_table.empty_state.payroll.description'
      ),
    },
    type: InsightTableType.Payroll,
  }
}
